const { createSlice, createAsyncThunk, createDraftSafeSelector } = require("@reduxjs/toolkit");
import Axios from "axios";
import { mergeObject } from "src/utils";
import { FS } from "../other/constant";

//TODO:
const client = Axios.create({
  baseURL: "https://scoringapi.trava.finance/nftdashboard",
});

const initialState = {
  fetchOvervieDataStatus: FS.INITIAL,
  overview: undefined,
  marketCap: undefined,
  marketPlaceTrend: undefined,
  holder: undefined,
  trader: undefined,
  averagePrice: undefined,
  knightStaking: undefined
};

const trimArray = (records, step = 2) => {
  return records.filter((item, index) => {
    return (records.length - index + 1) % step == 0;
  });
};

export const fetchOvervieData = createAsyncThunk("statisticSlice/fetchOvervieData", async ({ range }, thunkApi) => {
  const params = {
    range_time: range || "24h",
  };
  const res = await client.get("/v1/dashboard/nft/trava_armoury/bsc/stats", { params }).then((res) => res.data);
  if (res.success) {
    return res.result;
  } else {
    throw new Error("API error!");
  }
});

export const fetchMarketCapData = createAsyncThunk("statisticSlice/fetMcharketCapData", async ({ range }, thunkApi) => {
  const intervalList = {
    "24h": "1h",
    "7d": "24h",
    "30d": "24h",
    "3m": "7d",
  };
  const params = {
    range_time: range || "24h",
    interval: intervalList[range || "24h"],
  };
  const res = await client
    .get("/v1/dashboard/nft/trava_armoury/bsc/market-cap-volume", { params })
    .then((res) => res.data);
  if (res.success) {
    let marketCapData = res.result?.marketCapLogs || {};
    marketCapData = Object.keys(marketCapData).map((key) => [
      parseInt(key) * 1000,
      parseInt(marketCapData[key].marketCap.toFixed(0)),
    ]);
    let tradingVolumeData = res.result?.tradingVolumeLogs || {};
    tradingVolumeData = Object.keys(tradingVolumeData).map((key) => [
      parseInt(key) * 1000,
      parseInt(tradingVolumeData[key].volume.toFixed(0)),
    ]);
    //TODO:
    // if (range == "7d") {
    //   marketCapData = trimArray(marketCapData, 4);
    //   tradingVolumeData = trimArray(tradingVolumeData, 4);
    // }
    return {
      marketCapData,
      tradingVolumeData,
    };
  } else {
    throw new Error("API error!");
  }
});

export const fetchHolderData = createAsyncThunk("statisticSlice/fetchHolderData", async ({ range }, thunkApi) => {
  const intervalList = {
    "24h": "1h",
    "7d": "24h",
    "30d": "24h",
    "3m": "7d",
  };
  const params = {
    range_time: range || "24h",
    interval: intervalList[range || "24h"],
  };
  const res = await client.get("/v1/nft/trava_armoury/bsc/history/holder", { params }).then((res) => res.data);
  if (res.success) {
    let holderData = res.result || {};
    holderData = Object.keys(holderData).map((key) => [parseInt(key) * 1000, holderData[key]]);
    return holderData;
  } else {
    throw new Error("API error!");
  }
});

export const fetchTraderData = createAsyncThunk("statisticSlice/fetchTraderData", async ({ range }, thunkApi) => {
  const intervalList = {
    "24h": "1h",
    "7d": "24h",
    "30d": "24h",
    "3m": "7d",
  };
  const params = {
    range_time: range || "24h",
    interval: intervalList[range || "24h"],
  };
  const res = await client.get("/v1/nft/trava_armoury/bsc/history/trader", { params }).then((res) => res.data);
  if (res.success) {
    let buyer = res.result?.buyer || {};
    buyer = Object.keys(buyer).map((key) => [parseInt(key) * 1000, buyer[key]]);
    let seller = res.result?.seller || {};
    seller = Object.keys(seller).map((key) => [parseInt(key) * 1000, seller[key]]);
    let all = res.result?.all || {};
    all = Object.keys(all).map((key) => [parseInt(key) * 1000, all[key]]);
    //TODO:
    // if (range == "7d") {
    //   all = trimArray(all, 8);
    //   seller = trimArray(seller, 8);
    //   buyer = trimArray(buyer, 8);
    // } else if (range == "3m") {
    //   all = trimArray(all, 2);
    //   seller = trimArray(seller, 2);
    //   buyer = trimArray(buyer, 2);
    // }
    return { all, seller, buyer };
  } else {
    throw new Error("API error!");
  }
});
export const fetchAveragePrice = createAsyncThunk("statisticSlice/fetchAveragePrice", async ({ range }, thunkApi) => {
  const intervalList = {
    "24h": "1h",
    "7d": "24h",
    "30d": "24h",
    "3m": "7d",
  };
  const params = {
    range_time: range || "24h",
    interval: intervalList[range || "24h"],
  };
  const res = await client.get("/v1/nft/trava_armoury/bsc/history/average-price", { params }).then((res) => res.data);
  if (res.success) {
    const priceData = res.result || {};
    let copper = Object.keys(priceData).map((key) => [
      parseInt(key) * 1000,
      parseInt(priceData[key].copper.toFixed(0)),
    ]);
    let silver = Object.keys(priceData).map((key) => [
      parseInt(key) * 1000,
      parseInt(priceData[key].silver.toFixed(0)),
    ]);
    let gold = Object.keys(priceData).map((key) => [parseInt(key) * 1000, parseInt(priceData[key].gold.toFixed(0))]);
    let diamond = Object.keys(priceData).map((key) => [
      parseInt(key) * 1000,
      parseInt(priceData[key].diamond.toFixed(0)),
    ]);
    let crystal = Object.keys(priceData).map((key) => [
      parseInt(key) * 1000,
      parseInt(priceData[key].crystal.toFixed(0)),
    ]);
    return { copper, silver, gold, diamond, crystal };
  } else {
    throw new Error("API error!");
  }
});
export const fetchKnightStaking = createAsyncThunk("statisticSlice/fetchKnightStaking", async ({ range }, thunkApi) => {
  const intervalList = {
    "24h": "1h",
    "7d": "24h",
    "30d": "24h",
    "3m": "7d",
  };
  const params = {
    range_time: range || "24h",
    interval: intervalList[range || "24h"],
  };
  const res = await client.get("/v1/nft/trava_knight/bsc/history/staking", { params }).then((res) => res.data);
  if (res.success) {
    const stakingData = res.result || {};
    let copper = Object.keys(stakingData).map((key) => [
      parseInt(key) * 1000,
      parseInt(stakingData[key].copper.nftCount.toFixed(0)),
    ]);
    let silver = Object.keys(stakingData).map((key) => [
      parseInt(key) * 1000,
      parseInt(stakingData[key].silver.nftCount.toFixed(0)),
    ]);
    let gold = Object.keys(stakingData).map((key) => [parseInt(key) * 1000, parseInt(stakingData[key].gold.nftCount.toFixed(0))]);
    let diamond = Object.keys(stakingData).map((key) => [
      parseInt(key) * 1000,
      parseInt(stakingData[key].diamond.nftCount.toFixed(0)),
    ]);
    let crystal = Object.keys(stakingData).map((key) => [
      parseInt(key) * 1000,
      parseInt(stakingData[key].crystal.nftCount.toFixed(0)),
    ]);
    return { copper, silver, gold, diamond, crystal };
  } else {
    throw new Error("API error!");
  }
});

export const fetchMarketPlaceTrend = createAsyncThunk(
  "statisticSlice/fetchMarketPlaceTrend",
  async ({ range }, thunkApi) => {
    const intervalList = {
      "24h": "1h",
      "7d": "24h",
      "30d": "24h",
      "3m": "7d",
    };
    const params = {
      range_time: range || "24h",
      interval: intervalList[range || "24h"],
    };
    const res = await client.get("/v1/nft/trava_armoury/bsc/history/market-place", { params }).then((res) => res.data);
    let tradingVolumeData = res.result.tradingVolumeLogs || {};
    tradingVolumeData = Object.keys(tradingVolumeData).map((key) => [
      parseInt(key) * 1000,
      parseInt(tradingVolumeData[key].volume.toFixed(0)),
    ]);
    let buyData = res.result.buyOnSale || {};
    buyData = Object.keys(buyData).map((key) => [parseInt(key) * 1000, parseInt(buyData[key].volume.toFixed(0))]);
    let sellData = res.result.sellOnSale || {};
    sellData = Object.keys(sellData).map((key) => [parseInt(key) * 1000, parseInt(sellData[key].volume.toFixed(0))]);
    // TODO:
    // if (range == "7d") {
    //   tradingVolumeData = trimArray(tradingVolumeData, 8);
    //   buyData = trimArray(buyData, 8);
    //   sellData = trimArray(sellData, 8);
    // } else if (range == "3m") {
    //   tradingVolumeData = trimArray(tradingVolumeData, 2);
    //   buyData = trimArray(buyData, 2);
    //   sellData = trimArray(sellData, 2);
    // }
    return {
      tradingVolumeData,
      buyData,
      sellData,
    };
  }
);

const statisticSlice = createSlice({
  name: "statisticSlice",
  initialState: initialState,
  reducers: {
    updateArmouryRegistryConfig: (state, action) => {
      state.armouryRegistryConfig = action.payload;
    },
  },
  extraReducers: {
    [fetchOvervieData.fulfilled]: (state, action) => {
      state.overview = action.payload;
    },
    [fetchOvervieData.rejected]: (state, action) => {
      state.overview = undefined;
    },
    [fetchMarketCapData.fulfilled]: (state, action) => {
      state.marketCap = action.payload;
    },
    [fetchMarketCapData.rejected]: (state, action) => {
      state.marketCap = undefined;
    },
    [fetchMarketPlaceTrend.fulfilled]: (state, action) => {
      state.marketPlaceTrend = action.payload;
    },
    [fetchMarketPlaceTrend.rejected]: (state, action) => {
      state.marketPlaceTrend = undefined;
    },
    [fetchHolderData.fulfilled]: (state, action) => {
      state.holder = action.payload;
    },
    [fetchHolderData.rejected]: (state, action) => {
      state.holder = undefined;
    },
    [fetchTraderData.fulfilled]: (state, action) => {
      state.trader = action.payload;
    },
    [fetchTraderData.rejected]: (state, action) => {
      state.trader = undefined;
    },
    [fetchAveragePrice.fulfilled]: (state, action) => {
      state.averagePrice = action.payload;
    },
    [fetchAveragePrice.rejected]: (state, action) => {
      state.averagePrice = undefined;
    },
    [fetchKnightStaking.fulfilled]: (state, action) => {
      state.knightStaking = action.payload;
    },
    [fetchKnightStaking.rejected]: (state, action) => {
      state.knightStaking = undefined;
    },
  },
});
export const selectStatisticSlice = (state) => state.statisticSlice;

export default statisticSlice.reducer;
export const { updateArmouryRegistryConfig } = statisticSlice.actions;
